import i18n from '@/utils/i18n'

const languages = i18n.messages[i18n.locale].router
  
export default [
    {
        path: '/home',
        name: 'home',
		subheader: languages.home,
        component: resolve => require(['@/pages/home/index'], resolve),
        meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: languages.application.title1,
            permCode: "13",
            icon: "bank",
        },
    },
]
  